import { apiFetch } from './client';
import type { SearchAdapter } from './types';
import type { SearchHit, SearchOptions } from '@/lib/search/search-service';

const INLINE_SUGGESTION_MAX_RESULTS = 3;

export async function searchDocumentSuggestions(query: string): Promise<SearchHit[]> {
  const results = await apiFetch<SearchHit[]>(
    '/search?q=' + encodeURIComponent(query),
  );
  return results.slice(0, INLINE_SUGGESTION_MAX_RESULTS);
}

async function searchDocuments(query: string, options?: Omit<SearchOptions, 'query'>): Promise<SearchHit[]> {
  const params = new URLSearchParams({ q: query });
  if (options?.startDate) params.set('start_date', options.startDate);
  if (options?.endDate) params.set('end_date', options.endDate);
  if (options?.tags && options.tags.length > 0) {
    for (const tag of options.tags) {
      params.append('tags', tag);
    }
  }
  return apiFetch<SearchHit[]>(`/search?${params.toString()}`);
}

export const httpSearchAdapter: SearchAdapter = {
  searchDocumentSuggestions,
  searchDocuments,
};
